/**
 * Types of professional identifications
 * @see IDENTIFICACAO_PROFISSIONAL table on fopag database
 */
export const ProfessionalIdentificationTypes = {
  CLT: 1,
  ESTRATEGICO: 2,
  BENEFICIOS: 3,
  COOPERADO: 4,
  ESTAGIARIO: 5,
  TEMPORARIO: 6,
  AUTONOMO: 7,
} as const;
